const WAREHOUSE_PRICE_MODES = {
  WEIGHT: 'weight',
  UNIT: 'unit',
};

export { WAREHOUSE_PRICE_MODES };
